import React from "react";
import { Link } from "react-router-dom";
import { IndosbookMark } from "./IndosbookLogo";
import { Anchor } from "lucide-react";

// Two-column auth shell: brand panel + form
const AuthLayout = ({ title, subtitle, children, footer }) => {
  return (
    <div className="flex min-h-screen bg-white">
      {/* Brand panel */}
      <div className="indos-grid-white relative hidden w-1/2 overflow-hidden bg-[#FF4500] lg:flex lg:flex-col lg:justify-between p-12">
        <div className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-white/10 blur-3xl" />
        <Link to="/" className="relative flex items-center gap-2">
          <IndosbookMark size={34} inverted />
          <span
            className="text-2xl font-extrabold lowercase text-white"
            style={{ fontFamily: '"Poppins", Helvetica, Arial, sans-serif' }}
          >
            indosbook
          </span>
        </Link>

        <div className="relative">
          <h1
            className="text-4xl font-extrabold leading-tight text-white"
            style={{ fontFamily: '"Poppins", Helvetica, Arial, sans-serif' }}
          >
            One Nation,
            <br />
            One Maritime Community.
          </h1>
          <p className="mt-4 max-w-sm text-white/90">
            The social platform for seafarers, shipping companies and maritime
            institutes. No agents. No excuses. Join real ships.
          </p>
        </div>

        <div className="relative flex items-center gap-2 text-sm text-white/80">
          <Anchor className="h-4 w-4" /> Built for seafarers, by seafarers
        </div>

        <Anchor className="pointer-events-none absolute -bottom-10 -right-10 h-56 w-56 text-white/10" />
      </div>

      {/* Form panel */}
      <div className="indos-hero-mesh indos-grid-soft relative flex w-full flex-col justify-center px-6 py-10 sm:px-12 lg:w-1/2">
        <div className="relative mx-auto w-full max-w-md rounded-3xl border border-stone-200/70 bg-white/90 p-6 shadow-sm backdrop-blur-sm sm:p-8">
          <Link to="/" className="mb-8 flex items-center gap-2 lg:hidden">
            <IndosbookMark size={30} />
            <span
              className="text-xl font-extrabold lowercase text-[#0B2D8C]"
              style={{ fontFamily: '"Poppins", Helvetica, Arial, sans-serif' }}
            >
              indosbook
            </span>
          </Link>

          <h2 className="font-heading text-3xl font-extrabold text-[#0B2D8C]">{title}</h2>
          <p className="mt-2 text-[15px] text-gray-500">{subtitle}</p>

          <div className="mt-8">{children}</div>

          {footer && <div className="mt-6 text-center text-sm text-gray-600">{footer}</div>}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
